import React, { useState } from "react";
import PropTypes from "prop-types";
import { useMutation } from "react-apollo";

import { Fieldset, Title } from "rbx";

import { EditFormButtonGroup } from "../inputs";

import { ourToast as toast } from "../../utils";

import {
  UPDATE_BOOKING_CODE_MUTATION,
  DELETE_BOOKING_CODE_MUTATION
} from "../../graphql/BookingCodes/BookingCodes.graphql";

import BookingCodeForm from "./BookingCodeForm";

const INITIAL_STATE = {
  BookingCode: "",
  Description: "",
  MultipleDays: true,
  Active: true,
  Color: "",
  CodeCatgRecIdRef: ""
};

const EditBookingCodeForm = ({ bookingCode, onComplete }) => {
  const [inputs, setInputs] = useState({ ...INITIAL_STATE, ...bookingCode });
  const [updateBookingCode, { loading }] = useMutation(
    UPDATE_BOOKING_CODE_MUTATION,
    {
      refetchQueries: ["ALL_BOOKING_CODES_QUERY", "SINGLE_CUSTOMER_QUERY"]
    }
  );
  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({ ...inputs, [e.target.name]: value });
  };
  const handleSave = async e => {
    e.preventDefault();
    try {
      const obj = Object.keys(INITIAL_STATE).reduce(
        (acc, curr) =>
          inputs[curr] !== null ? { ...acc, [curr]: inputs[curr] } : acc,
        {}
      );
      await updateBookingCode({
        variables: {
          data: {
            ...obj,
            CodeCatgRecIdRef: obj.CodeCatgRecIdRef
              ? parseInt(obj.CodeCatgRecIdRef)
              : null
          },
          where: {
            RecId: parseInt(bookingCode.RecId)
          }
        }
      });
      onComplete();
      toast.success("Booking Code updated successfully.");
    } catch (err) {
      toast.error("Error updating Booking Code.");
    }
  };
  return (
    <form
      className="edit-booking-code-form"
      id="edit-booking-code-form"
      onSubmit={handleSave}
    >
      <Title>Edit Booking Code</Title>
      <Fieldset disabled={loading}>
        <BookingCodeForm inputs={inputs} onChange={handleChange} />
        <EditFormButtonGroup
          deleteMutation={DELETE_BOOKING_CODE_MUTATION}
          form="edit-booking-code-form"
          refetchQueries={["ALL_BOOKING_CODES_QUERY"]}
          variables={{ where: { RecId: parseInt(bookingCode.RecId) } }}
          onComplete={onComplete}
        />
      </Fieldset>
    </form>
  );
};

EditBookingCodeForm.propTypes = {
  bookingCode: PropTypes.object,
  onComplete: PropTypes.func
};

export default EditBookingCodeForm;
